module.exports = __webpack_public_path__ + "img/logo.4ec954e0.png";